import { Helper } from "../util/helper";
import React from "react"
export class DragAndDrop extends React.Component<DragAndDropProps, DragAndDropState> {
    private dropRef: HTMLDivElement;
    private dragCounter: number;
    private style: React.CSSProperties;

    constructor(props: DragAndDropProps) {
        super(props)
        this.dragCounter = 0;
        this.state = {
            drag: false
        }
        this.style = Helper.getValueOrDefault(props.style, {});
        this.style.display = 'inline-block';
        this.style.position = 'relative';

    }

    handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }
    handleDragIn = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter++
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ drag: true })
        }
    }
    handleDragOut = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.dragCounter--
        if (this.dragCounter === 0) {
            this.setState({ drag: false })
        }
    }
    handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ drag: false })
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.props.handleDrop(e.dataTransfer.files)
            e.dataTransfer.clearData()
            this.dragCounter = 0
        }
    }
    componentDidMount() {
        let div = this.dropRef;
        div.addEventListener('dragenter', this.handleDragIn)
        div.addEventListener('dragleave', this.handleDragOut)
        div.addEventListener('dragover', this.handleDrag)
        div.addEventListener('drop', this.handleDrop)
    }
    componentWillUnmount() {
        let div = this.dropRef
        div.removeEventListener('dragenter', this.handleDragIn)
        div.removeEventListener('dragleave', this.handleDragOut)
        div.removeEventListener('dragover', this.handleDrag)
        div.removeEventListener('drop', this.handleDrop)
    }


    private setDropRef = (ref: HTMLDivElement) => {
        this.dropRef = ref;
    }

    render() {
        return (
            <>
                <div style={this.style} ref={this.setDropRef}>
                    {this.state.drag &&
                        <div
                            style={{
                                border: 'dashed #2196f3 4px',
                                backgroundColor: 'rgba(255,255,255,.8)',
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                zIndex: 9999
                            }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: 0,
                                    left: 0,
                                    textAlign: 'center',
                                    color: '#2196f3',
                                    fontSize: 36
                                }}
                            >
                            </div>
                        </div>
                    }
                    {this.props.children}
                </div>
            </>        
            );

    }
}

interface DragAndDropState {
    drag: boolean
}

export interface DragAndDropProps extends React.PropsWithChildren{
    handleDrop: (files: FileList) => void;
    style?: React.CSSProperties;
}